export default "https://cdn-static.gokick.com/assets/c736ccdc0086f37925b8733f1854c980393ad61e/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";